import React from 'react';

const FormField: React.FC<{
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  type?: string;
  className?: string;
  form?: string;
  name?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
  maxLength?: number;
  onBlur?: () => void;
}> = ({
  placeholder,
  value,
  onChange,
  error,
  type = 'text',
  className = '',
  form,
  name,
  disabled,
  min,
  max,
  maxLength,
  onBlur,
}) => {
  return (
    <>
      <div className={`${className}`}>
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          name={name}
          disabled={disabled}
          min={min}
          max={max}
          maxLength={maxLength}
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.value)}
          className={`
          ${
            error && form !== 'billing'
              ? 'text-smoothRed border-pinkNegative border w-full rounded-md bg-surfaceNegative px-4 py-4'
              : 'w-full border-none rounded-md px-4 py-4 text-headlineGrayscale focus:outline-none focus:ring-none focus:border-none bg-transparent'
          }
        `}
        />
        {error && (
          <div className="mb-1 transition-all duration-300 ease-in-out">
            <p className="text-smoothRed text-sm font-medium animate-fade-in">
              {error}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default FormField;
